import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { BiArrowBack } from 'react-icons/bi';
import { useState } from 'react';

const AllProject = () => {
  const [data, setData] = useState([])



  // fetch data 
  useEffect(() => {
    fetch("/project.json")
      .then(res => res.json())
      .then(data => setData(data))

  }, [])


  return (
    <div className="p-4">
      <Link to="/">
        <div className="grid justify-center mt-4 h1p sticky top-0 z-[50]">
          <button type="button" class="bg-gray-800 text-white rounded-r-md py-2 border-l border-gray-200 hover:bg-primary hover:text-white px-3">
            <div class="flex flex-row align-middle">
              <span class="mr-2">Let's  Home Page </span>
              <svg class="w-5 ml-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd"></path>
              </svg>
            </div>
          </button>
        </div>
      </Link>
      <h1 className="text-2xl font-bold">
        01.<span className="text-primary"> Projects_Done 20+ </span>
      </h1>

      <div className="grid  mt-4 justify-content-center sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">

        {data?.map((project) => (
          <>
            <div className="card w-84  shadow-xl text-gray-300">
              <figure>
                <img
                  className="h-[200px]"
                  src={project?.img}
                  alt="Shoes"
                />
              </figure>
              <div className="card-body">
                <h2 className="card-title">{project.projectName}</h2>
                <div className="card-actions">
                  {project.technology?.map((t) =>
                    <>
                      <div className="badge badge-outline skill-border-react">
                        {t}
                      </div>
                    </>)}



                </div>
                <p>{project.description} </p>
                <div className="flex justify-between">
                  <a target="_blank" href={project.live}>
                    <div className="badge badge-outline px-4 live-button  bg-primary">
                      live
                    </div>
                  </a>

                  <a target="_blank" href={project.git}>
                    <div className="badge badge-outline px-4 live-button">Git</div>
                  </a>
                </div>
              </div>
            </div>
          </>
        ))}


      </div>
    </div>
  );
};

export default AllProject;